import UserListView from '@/views/Users/UserListView/UserListView.vue'
import UserDetailView from '@/views/Users/UserDetailView/UserDetailView.vue'

export default [
  { path: '/users', component: UserListView, name: 'UserList' },
  { path: '/users/:userID', component: UserDetailView, name: 'UserDetail' }
]
